// PAGINATION COMPONENT
import React from "react";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

export default function Pagination({
    page = 1,
    rowsPerPage = 5,
    count = 0,
    onRowsPerPageChange = () => { },
    onPageChange = () => { },
    sx,
    ...other
}) {
    // Skip rendering if no data
    if (!count || count === 0) return null;

    const totalPages = Math.ceil(count / rowsPerPage);

    // Page is passed as 1-based (for display purposes), but we need to convert
    // to 0-based when communicating with the parent component
    const currentPageZeroBased = page - 1;

    const handleNextPage = () => {
        if (currentPageZeroBased < totalPages - 1) {
            onPageChange(currentPageZeroBased + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPageZeroBased > 0) {
            onPageChange(currentPageZeroBased - 1);
        }
    };

    return (
        <div className="pagination-block"
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                ...sx,
            }}
            {...other}
        >

            <select
                className="pagination-select"
                value={rowsPerPage}
                onChange={(e) => onRowsPerPageChange(page, parseInt(e.target.value, 10))}
            >
                <option value={5}>5 per page</option>
                <option value={10}>10 per page</option>
                <option value={20}>20 per page</option>
            </select>

            <div className="">
                <button
                    className="pagination-left-btn btn"
                    onClick={handlePrevPage}
                    disabled={currentPageZeroBased <= 0}
                >
                   <KeyboardArrowLeftIcon />
                </button>

                <span style={{ margin: "0 15px" }} className="pagination-numbers">
                    {page} of {totalPages}
                </span>

                <button
                    className="pagination-right-btn btn"
                    onClick={handleNextPage}
                    disabled={currentPageZeroBased >= totalPages - 1}
                >
                   <KeyboardArrowRightIcon />
                </button>
            </div>


        </div>
    );
}